import { render } from "./PasswordControl.vue?vue&type=template&id=0b804df9&scoped=true"
import script from "./PasswordControl.vue?vue&type=script&lang=js"
export * from "./PasswordControl.vue?vue&type=script&lang=js"

import "./PasswordControl.vue?vue&type=style&index=0&id=0b804df9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b804df9"]])

export default __exports__